import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { SUBSCRIPTIONADD } from "../../../../store/subscription/actions";
import { toast } from "react-toastify";
import FadeLoader from "react-spinners/FadeLoader";
import { useNavigate } from "react-router-dom";

const AddSubscription = () => {
  const { loading } = useSelector((state) => state.Subscription);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    avatar: "",
    monthlyMinutes: "",
    benefits: [""],
    status: "active",
    isAvatarUnlimited: false,
    prices: [
      {
        name: "",
        price: "",
        interval: "",
        intervalCount: "",
        currency: "USD",
        stripePriceId: "",
        status: "active",
      },
    ],
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormData({
        ...formData,
        [name]: checked,
        // Set avatar to 0 when unlimited is checked
        ...(name === "isAvatarUnlimited" && checked ? { avatar: 0 } : {}),
      });
    } else if (type === "number") {
      if (value === "") {
        setFormData({
          ...formData,
          [name]: "",
        });
        return;
      }
      const numericValue = parseInt(value, 10);
      if (isNaN(numericValue) || numericValue < 0) {
        return;
      }
      setFormData({
        ...formData,
        [name]: numericValue,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleBenefitsChange = (index, value) => {
    const newBenefits = [...formData.benefits];
    newBenefits[index] = value;
    setFormData({ ...formData, benefits: newBenefits });
  };

  const addBenefit = () => {
    setFormData({
      ...formData,
      benefits: [...formData.benefits, ""],
    });
  };

  const removeBenefit = (index) => {
    const newBenefits = formData.benefits.filter((_, i) => i !== index);
    setFormData({ ...formData, benefits: newBenefits });
  };

  const handlePriceChange = (index, field, value) => {
    const newPrices = [...formData.prices];

    if (field === "price" || field === "intervalCount") {
      if (value === "") {
        newPrices[index][field] = "";
      } else {
        const numericValue = parseInt(value, 10);
        if (!isNaN(numericValue) && numericValue >= 0) {
          newPrices[index][field] = value;
        }
      }
    } else {
      newPrices[index][field] = value;
    }

    setFormData({ ...formData, prices: newPrices });
  };

  const addPrice = () => {
    setFormData({
      ...formData,
      prices: [
        ...formData.prices,
        {
          name: "",
          price: "",
          interval: "",
          intervalCount: "",
          currency: "USD",
          stripePriceId: "",
          status: "active",
        },
      ],
    });
  };

  const removePrice = (index) => {
    const newPrices = formData.prices.filter((_, i) => i !== index);
    setFormData({ ...formData, prices: newPrices });
  };

  const handleSubmit_ = (info) => {
    try {
      const callback = (err, res) => {
        if (err) {
          console.error(err, "error message");
          toast.error(err);
        } else {
          console.log(res);
          toast.success("Plan Added successfully");
          navigate("/subscription-plan");
          setFormData({
            name: "",
            avatar: "",
            monthlyMinutes: "",
            benefits: [""],
            status: "active",
            isAvatarUnlimited: false,
            prices: [
              {
                name: "",
                price: "",
                interval: "",
                intervalCount: "",
                currency: "USD",
                stripePriceId: "",
                status: "active",
              },
            ],
          });
        }
      };
      dispatch(
        SUBSCRIPTIONADD({
          data: info,
          callback,
        })
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <section className="addForm position-relative py-3">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="cardCstm p-3 rounded bg-white">
                <Form
                  className="mx-auto"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit_(formData);
                  }}
                >
                  <div className="py-3">
                    <div className="topHead pb-2">
                      <h5 className="m-0 fw-sbold" style={{ color: "#2E3A59" }}>
                        Add Subscription:
                      </h5>
                    </div>
                    <div className="mx-auto" style={{ maxWidth: 777 }}>
                      <Row className="justify-content-center">
                        <Col md="6" className="my-2">
                          <label className="form-label fw-sbold">Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter Plan Name"
                          />
                        </Col>

                        <Col md="6" className="my-2">
                          <label className="form-label fw-sbold">Avatar</label>
                          <input
                            type="number"
                            className="form-control"
                            name="avatar"
                            value={formData.avatar}
                            onChange={handleChange}
                            placeholder="Enter Avatar Count"
                            disabled={formData.isAvatarUnlimited}
                          />
                        </Col>

                        <Col md="6" className="my-2">
                          <label className="form-label fw-sbold">
                            Monthly Minutes
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            name="monthlyMinutes"
                            value={formData.monthlyMinutes}
                            onChange={handleChange}
                            placeholder="Enter Monthly Minutes"
                          />
                        </Col>

                        <Col md="6" className="my-2">
                          <label className="form-label fw-sbold">Status</label>
                          <select
                            className="form-control"
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                          >
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                          </select>
                        </Col>

                        <Col md="6" className="my-2">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="isAvatarUnlimited"
                              name="isAvatarUnlimited"
                              checked={formData.isAvatarUnlimited}
                              onChange={handleChange}
                            />
                            <label
                              className="form-check-label fw-sbold"
                              htmlFor="isAvatarUnlimited"
                            >
                              Unlimited Avatars
                            </label>
                          </div>
                        </Col>

                        {/* Benefits (Dynamic Array) */}
                        <Col md="12" className="my-3">
                          <label className="form-label fw-sbold">
                            Benefits
                          </label>
                          {formData.benefits.map((benefit, index) => (
                            <div
                              key={index}
                              className="d-flex align-items-center mb-2"
                            >
                              <input
                                type="text"
                                className="form-control me-2"
                                value={benefit}
                                onChange={(e) =>
                                  handleBenefitsChange(index, e.target.value)
                                }
                                placeholder="Enter benefit"
                              />
                              <Button
                                variant="danger"
                                className="btn-sm"
                                onClick={() => removeBenefit(index)}
                                disabled={formData.benefits.length === 1}
                              >
                                Remove
                              </Button>
                            </div>
                          ))}
                          <Button className="mt-2 btn-sm" onClick={addBenefit}>
                            Add More
                          </Button>
                        </Col>

                        {/* Prices (Dynamic Array) */}
                        <Col md="12" className="my-3">
                          <div className="border rounded p-3">
                            <label className="form-label fw-sbold mb-3">
                              Pricing Plans
                            </label>
                            {formData.prices.map((price, index) => (
                              <div
                                key={index}
                                className="border rounded p-3 mb-3 bg-light"
                              >
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <h6 className="m-0">
                                    Price Plan {index + 1}
                                  </h6>
                                  <Button
                                    variant="danger"
                                    size="sm"
                                    onClick={() => removePrice(index)}
                                    disabled={formData.prices.length === 1}
                                  >
                                    Remove Plan
                                  </Button>
                                </div>
                                <Row>
                                  <Col md="6" className="my-2">
                                    <label className="form-label">
                                      Plan Name
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={price.name}
                                      onChange={(e) =>
                                        handlePriceChange(
                                          index,
                                          "name",
                                          e.target.value
                                        )
                                      }
                                      placeholder="e.g., Monthly plan"
                                    />
                                  </Col>

                                  <Col md="6" className="my-2">
                                    <label className="form-label">Price</label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={price.price}
                                      onChange={(e) =>
                                        handlePriceChange(
                                          index,
                                          "price",
                                          e.target.value
                                        )
                                      }
                                      placeholder="Enter price"
                                    />
                                  </Col>

                                  <Col md="6" className="my-2">
                                    <label className="form-label">
                                      Interval
                                    </label>
                                    <select
                                      className="form-control"
                                      value={price.interval}
                                      onChange={(e) =>
                                        handlePriceChange(
                                          index,
                                          "interval",
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="">Select Interval</option>
                                      <option value="month">Month</option>
                                      <option value="year">Year</option>
                                    </select>
                                  </Col>

                                  <Col md="6" className="my-2">
                                    <label className="form-label">
                                      Interval Count
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      value={price.intervalCount}
                                      onChange={(e) =>
                                        handlePriceChange(
                                          index,
                                          "intervalCount",
                                          e.target.value
                                        )
                                      }
                                      placeholder="e.g., 1, 3, 12"
                                    />
                                  </Col>

                                  <Col md="6" className="my-2">
                                    <label className="form-label">
                                      Currency
                                    </label>
                                    <select
                                      className="form-control"
                                      value={price.currency}
                                      onChange={(e) =>
                                        handlePriceChange(
                                          index,
                                          "currency",
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="USD">USD</option>
                                      <option value="EUR">EUR</option>
                                      <option value="GBP">GBP</option>
                                      <option value="INR">INR</option>
                                    </select>
                                  </Col>

                                  <Col md="6" className="my-2">
                                    <label className="form-label">
                                      Stripe Price ID
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={price.stripePriceId}
                                      onChange={(e) =>
                                        handlePriceChange(
                                          index,
                                          "stripePriceId",
                                          e.target.value
                                        )
                                      }
                                      placeholder="Enter Stripe Price ID"
                                    />
                                  </Col>

                                  <Col md="6" className="my-2">
                                    <label className="form-label">Status</label>
                                    <select
                                      className="form-control"
                                      value={price.status}
                                      onChange={(e) =>
                                        handlePriceChange(
                                          index,
                                          "status",
                                          e.target.value
                                        )
                                      }
                                    >
                                      <option value="active">Active</option>
                                      <option value="inactive">Inactive</option>
                                    </select>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                            <Button className="mt-2" onClick={addPrice}>
                              Add Another Price Plan
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <div className="py-3">
                    <div className="mx-auto" style={{ maxWidth: 777 }}>
                      <Row>
                        <Col md="5" className="my-2">
                          <Button
                            className="d-flex align-items-center justify-content-center commonBtn w-100 fw-sbold"
                            type="submit"
                          >
                            Submit
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddSubscription;